import React, { Component } from 'react';

import classes from './TripTrackingModal.css';
import Aux from '../../hoc/Auxiliary/Auxiliary';
import Backdrop from '../UI/Backdrop/Backdrop';
import personImg from '../../assets/images/person-icon.png';
import deleteImg from '../../assets/images/delete-icon.png';
import closeImg from '../../assets/images/close-icon.png';
import arrowImg from '../../assets/images/arrow-right-icon.png';
import phoneImg from '../../assets/images/phone-icon.png';
import plusImg from '../../assets/images/plus-icon.png';
import sideBySideImg from '../../assets/images/side-by-side-icon.png';
import stackedImg from '../../assets/images/stacked-icon.png';
import saveImg from '../../assets/images/save-icon.png';
import historyImg from '../../assets/images/history-icon.png';
import Icon from '../UI/Icon/Icon';
import Button from '../UI/Button/Button';
import ButtonIconConfirm from '../UI/ButtonIconConfirm/ButtonIconConfirm';
import ButtonIcon from '../UI/ButtonIcon/ButtonIcon';
import Input from '../UI/Input/Input';
import Spinner from '../UI/Spinner/Spinner';
import Tracking from '../../containers/TripTracking/Tracking/Tracking';

class TripTrackingModal extends Component {
  
  render () {

    let modalClass = classes.CardModal;
    return(
      <Aux>
        <Backdrop show={this.props.show} clicked={this.props.closeCard} />
        <div
          className={modalClass}
          style={{transform: this.props.show ? 'translateY(0)' : 'translateY(-100vh)',
                  opacity: this.props.show ? '1' : '0'}}>
          {
            this.props.tripTracking ?
            <Tracking
              editing={true}
              noRestrictions
              {...this.props.tripTracking}
            />
            : null
          }
        </div>
      </Aux>
    );
  }
};

export default TripTrackingModal;



// WEBPACK FOOTER //
// ./src/components/TripTrackingModal/TripTrackingModal.js